import { schema } from "normalizr"
import processTemplateItems from "../processTemplateItems"
import processTemplate from "./item"

export default new schema.Object({
  processTemplate,
  processTemplateItems,
})
